interface AppCalloutBannerFormattedPrimaryLabelProps {
  label: string;
  emphasizedPrefix?: string | null;
}

/** Renders app-callout copy with an optional bold prefix while keeping labels plain text. */
export const AppCalloutBannerFormattedPrimaryLabel = ({
  label,
  emphasizedPrefix,
}: AppCalloutBannerFormattedPrimaryLabelProps) => {
  if (!emphasizedPrefix || !label.startsWith(emphasizedPrefix)) {
    return <>{label}</>;
  }

  return (
    <>
      <strong>{emphasizedPrefix}</strong>
      {label.slice(emphasizedPrefix.length)}
    </>
  );
};
